import React, { useEffect, useState } from 'react';

import Traductor from '../../../Traductor';

import FormHeader from '../../common/FormHeader';
import TextInput from '../../common/TextInput';
import TicketingService from '../../../../services/TicketingService';
import Globals from '../../../../Globals';
import { withCookies } from 'react-cookie';
import Loading from '../../../../components/bronson/Loading';

const CreateTicketOriginForm = ({
    values,
    onChange,
    errors,
    touched,
    cookies,
    validateForm,
}) => {
    const t = new Traductor();
    const [loading, setLoading] = useState(false);

    const getInfoTicket = () => {
        if (values['plate'] !== '') {
            setLoading(true);
            new TicketingService()
                .getInfoTicket(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    values
                )
                .then(response => {
                    if (response !== undefined && response.body !== undefined) {
                        var infoTicket = {
                            plateAux: response.body.Matricula,
                            orderNumberAux: response.body.Contrato,
                        };
                        if (infoTicket.plateAux !== null) {
                            let order = '';
                            validateForm(true);
                            if (infoTicket.orderNumberAux !== null)
                                order = infoTicket.orderNumberAux;
                            onChange('orderNumber', order);
                        } else {
                            onChange('orderNumber', '');
                            validateForm(false);
                        }
                    }
                    setLoading(false);
                });
        }
    };

    return (
        <section className="c-form-section  js-form-section  js-is-fx">
            <Loading ariaBusy={loading} disableIcon={true} />
            <FormHeader text={t.getTraduction('TicketOrigin')} expanded />
            <div
                className="c-form-section__panel  js-form-section__panel"
                aria-hidden="false"
            >
                <div className="c-form-section__content">
                    <div className="o-fieldset__row u-pb">
                        <div className="o-layout__item u-1/2 u-1/2@m">
                            <TextInput
                                label={t.getTraduction('Plate')}
                                name="plate"
                                values={values}
                                onChange={onChange}
                                errors={errors}
                                touched={touched}
                                row
                                buscador={false}
                                onBlur={getInfoTicket}
                            />
                        </div>
                        <div className="o-layout__item u-1/2 u-1/2@m">
                            <TextInput
                                label={t.getTraduction(
                                    'OperationCodePlaceholder'
                                )}
                                name="orderNumber"
                                values={values}
                                onChange={onChange}
                                //errors={errors}
                                //touched={touched}
                                row
                                buscador={false}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default withCookies(CreateTicketOriginForm);
